import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { AppLocale } from "@/i18n/constants";
import { contentEn } from "./content.en";
import { contentEs } from "./content.es";
import type { SiteContent } from "./content.types";

export type {
  AboutContent,
  AboutHighlight,
  MethodologyContent,
  MethodologyStep,
  ResourceItem,
  ResourcesPageCopy,
  ServiceItem,
  SiteContent,
} from "./content.types";

const contentByLocale: Record<AppLocale, SiteContent> = {
  es: contentEs,
  en: contentEn,
};

export function getContent(locale: AppLocale): SiteContent {
  return contentByLocale[locale] ?? contentEs;
}

export function useContent(): SiteContent {
  const { i18n } = useTranslation();
  const locale = (i18n.language === "en" ? "en" : "es") as AppLocale;
  return useMemo(() => getContent(locale), [locale]);
}
